import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { SharedModule } from 'ag-common-svc/shared/shared.module';
import { ChangeLogPhoneComponent } from './change-log-phone.component';
import { ChangeLogPipesModule } from '../../../pipes/change-log-pipes.module';

@NgModule({
  declarations: [ChangeLogPhoneComponent],
  imports: [CommonModule, SharedModule, ChangeLogPipesModule,],
  exports: [ChangeLogPhoneComponent],
})
export class ChangeLogPhoneModule {}
